import Create from './create'
import Paginate from 'vuejs-paginate'
import swal from 'sweetalert'
import Status from '@/components/status'

export default {
  name: 'position',
  components: {Create, Paginate, Status},
  props: [],
  data () {
    return {
      per_page: 20,
      position: {},
      errors: {},
      btn_submit: false,
      fields: [
        {
          key: 'name',
          sortable: true,
          label: this.$t('common.name')
        },
        {
          key: 'order',
          sortable: true,
          label: this.$t('common.order')
        },
        {
          key: 'status',
          label: this.$t('common.status')
        },
        {
          key: 'action',
          label: this.$t('common.action')
        }
      ]
    }
  },
  computed: {
    items () {
      return this.$store.getters['Position/getListPosition']
    },
    total () {
      return this.$store.getters['Position/getTotal']
    },
    last_page () {
      return this.$store.getters['Position/getLastpage']
    },
    options () {
      return this.$store.getters['Status/getStatusCheckerMaker']
    },
    fields () {
      return this.$store.getters['Position/getField']
    }
  },
  mounted () {
    this.$loading.start()
    Promise.all([
      this.$store.dispatch('Position/getListPosition', {page: 1, per_page: this.per_page}),
      this.$store.dispatch('Status/getListStatus')
    ]).then(res => {
      this.$loading.complete()
    }).catch(errors => {
      this.$loading.fail()
    })
  },
  methods: {
    clickCallback (page) {
      this.$loading.start()
      this.$store.dispatch('Position/getListPosition', {page: page, per_page: this.per_page}).then(res => {
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },

    changePerPage () {
      this.$loading.start()
      this.$store.dispatch('Position/getListPosition', {page: 1, per_page: this.per_page}).then(res => {
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },

    edit (position) {
      this.$loading.start()
      this.$store.dispatch('Position/showPosition', {position: position}).then(res => {
        this.position = res
        this.$loading.complete()
        this.$refs.edit.show()
      }).catch(errors => {
        this.$loading.fail()
      })
    },

    update () {
      this.btn_submit = true
      this.$loading.start()
      this.$store.dispatch('Position/updatePosition', {position: this.position}).then(res => {
        this.$loading.complete()
        this.btn_submit = false
        this.$refs.edit.hide()
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
      }).catch(errors => {
        this.btn_submit = false
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        this.$loading.fail()
      })
    },

    destroy (position) {
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
            this.$loading.start()
            this.$store.dispatch('Position/destroyPosition', {
              position: position
            }).then((res) => {
              this.$notify({
                group: 'success',
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
              this.$loading.complete()
            }).catch(errors => {
              this.$loading.complete()
            })
          }
        })
    },

    approval (position) {
      this.$loading.start()
      this.$store.dispatch('Position/approvalPosition', {
        position
      }).then(res => {
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    },

    rejection (position) {
      this.$loading.start()
      this.$store.dispatch('Position/rejectPosition', {
        position
      }).then(res => {
        this.$loading.complete()
      }).catch(errors => {
        this.$loading.fail()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/position/position.js